import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { CheckCircleSolidIcon, ExclamationTriangleSolidIcon, InformationCircleSolidIcon, AlarmBellSolidIcon } from '@compono/ui-icons';
import { AlertBase } from './AlertBase/index.js';
import { AlertContent } from './AlertContent/index.js';
import { AlertCloseButton } from './AlertCloseButton/AlertCloseButton.js';

var iconMap = {
    success: CheckCircleSolidIcon,
    warning: ExclamationTriangleSolidIcon,
    critical: ExclamationTriangleSolidIcon,
    infoPrimary: InformationCircleSolidIcon,
    infoSecondary: AlarmBellSolidIcon,
};
/**
 * @deprecated Alert has now been moved into createAlert,
 * please consider using [CoachTip](https://ui.compono.dev/?path=/docs/components-coachtip--interactive).
 * also see migration docs for [Alert](https://ui.compono.dev/?path=/docs/components-alert--interactive).
 */
var Alert = function (_a) {
    var _b = _a.tone, tone = _b === void 0 ? "success" : _b, _c = _a.size, size = _c === void 0 ? "md" : _c, _d = _a.hasIcon, hasIcon = _d === void 0 ? true : _d, children = _a.children, title = _a.title, onDismiss = _a.onDismiss, sx = _a.sx, props = __rest(_a, ["tone", "size", "hasIcon", "children", "title", "onDismiss", "sx"]);
    return (jsxs(AlertBase, __assign({ sx: __assign({ position: "relative" }, sx), tone: tone, size: size, icon: hasIcon ? iconMap[tone] : undefined }, props, { children: [jsx(AlertCloseButton, { onClick: onDismiss }), jsx(AlertContent, __assign({ title: title }, { children: children }))] })));
};
Alert.displayName = "Alert";

export { Alert };
//# sourceMappingURL=Alert.js.map
